<template>
  <v-content style="padding:10px">
    <loading v-if="loadingBar"> </loading>  
      <v-layout>
<!--       <template v-if="currentTable != 'create'">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="rows[currentTable]"
          item-key="name"
          class="elevation-1"
          hide-actions
        >
          <template slot="headers" slot-scope="props">
            <tr
                v-for="header in props.headers"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td v-for="(row, i) in headers">{{ props.item[headers[i].text] }}</td>
            </tr>
          </template>
        </v-data-table>
      </template> -->
      <v-flex lg8  v-show="currentTable == 'create' && !loadingBar">
        <v-label>1. Define desired number of columns</v-label>
        <v-select
          style="max-width:200px; margin-bottom:40px;"
          v-model="noCols"
          placeholder='No. Cols'
          :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        ></v-select>
        
      
            
      <v-flex sm2 v-show="currentTable == 'create' && loadingBar">
        <h3> Generating Database.. </h3>
      </v-flex>
<!--             <v-text-field v-if="currentTable == 'create' && !loadingBar" style="position:absolute;left:50%;top:20%" v-model="newTableName" placeholder="new table acc name"></v-text-field> -->
      <v-label>2. Design database contract names and types</v-label>
      <v-data-table
          v-if="currentTable == 'create' && !loadingBar"
          v-model="selected"
          :headers="headers"
          :items="rows['create']"
          class="elevation-4"
          hide-actions
        >

          <template slot="headers" slot-scope="props">
            
            <tr>
              <td>
                <span>account</span>
              </td>
              <td
                v-for="(header, i) in noCols"
              >
                <v-text-field v-model="newHeaders[i]" :placeholder="'Col ' + i + ' name'"></v-text-field>
              </td>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr >
              <td class="text-xs-right"><span>Account_name</span></td>
              <td v-for="(col, index) in noCols" :key="index" class="text-xs-right">
                <div>
                   
                  <v-btn-toggle v-model="toggle_exclusive[index]">
                    <v-btn style="margin-right:10px" @click="newTypes[index] = 'int'">
                      Int
                    </v-btn>
                    <v-btn @click="newTypes[index] = 'string'">
                      String
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

</v-content>
</template>

<script>

  import axios from "axios"


  

  var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
  var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

  // Don't forget to tell ScatterJS which plugins you are using.
  

    let loading = {
      data () {
        return {
          value: 0,
          query: false,
          show: true,
          interval: 0,
          color: 'blue'
        }
      },

      mounted () {
        this.queryAndIndeterminate()
      },

      beforeDestroy () {
        clearInterval(this.interval)
      },

      methods: {
        queryAndIndeterminate () {
          this.query = true
          this.show = true
          this.value = 0

          setTimeout(() => {
            this.query = false

            this.interval = setInterval(() => {
              if (this.value === 100) {
                clearInterval(this.interval)
                this.show = false
                return setTimeout(this.queryAndIndeterminate, 2000)
              }
              this.value += 25
              if (this.value === 25) {
                this.color = 'warning'
              } else if (this.value === 100) {
                this.color = 'success'
              }
            }, 1000)
          }, 2500)
        }
      },
      template:
        '<div>' +
          '<v-progress-linear ' +
          'v-model="value" ' +
          ':active="show" ' +
          ':indeterminate="query" height="20" :color="color"' +
          ':query="true"></v-progress-linear>' +
        '</div>'
    }

  export default {
    data: () => ({
        dialog: false,
        drawer: null,
        creating: true,
        toggle_exclusive: [
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2,
          2
        ],
        loadingBar: false,
        items: [],
        types: ['int', 'string'],
        newTypes: {},
        newHeaders: {},
        noCols: 3,
        currentTable: 'create',
        pagination: {
          sortBy: 'name'
        },
        selected: [],
        headers: [],
        rows: {"create": [""]},
        newTableName: ''
      }),
      created: function  () {
        
      },
      components: {
        loading
      },
      props: {
        source: String
      },
      watch: {
        noCols: function () {
          if (this.noCols == 1) {this.noCols = ['']}
          else if (this.noCols === 2) {this.noCols = ['', '']}
          else if (this.noCols === 3) {this.noCols = ['', '', '']}
          else if (this.noCols === 4) {this.noCols = ['', '', '', '']}
          else if (this.noCols === 5) {this.noCols = ['', '', '', '', '']}
          else if (this.noCols === 6) {this.noCols = ['', '', '', '', '', '']}
          else if (this.noCols === 7) {this.noCols = ['', '', '', '', '', '', '']}
          else if (this.noCols === 8) {this.noCols = ['', '', '', '', '', '', '', '']}
          else if (this.noCols === 9) {this.noCols = ['', '', '', '', '', '', '', '', '']}
          else if (this.noCols === 10) {this.noCols = ['', '', '', '', '', '', '', '', '', '']}
        },
        currentTable: function () {
          if (this.currentTable) {
            var rawHeaders = Object.keys(this.rows[this.currentTable][0])
            this.headers = []
            for (var i = 0; i < rawHeaders.length; i++) {
              this.headers.push({text: rawHeaders[i], value: rawHeaders[i]})
            }
          }
        }
      },
      methods: {
        download: function (filename, text) {
          var element = document.createElement('a');
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
          element.setAttribute('download', filename);

          element.style.display = 'none';
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);
        },
        isLoading: function () {
          this.loadingBar = true
          setTimeout( () => {
              this.loadingBar = false
              // this.currentTable = this.newTableName
          }, 8000)
        },
        compileTableForDispatch: function () {
          let self = this
          let headers = Object.values(self.newHeaders)
          let types = Object.values(self.newTypes)

          console.log(headers)
          console.log(types)

          let dispatch = {
            headers: [],
            types: []
          }

          for (let i = 0; i < headers.length; i++) {
            dispatch.headers.push(headers[i])
          }
          for (let t = 0; t < types.length; t++) {
            dispatch.types.push(types[t])
          }

          // add the table name to firebase
          let pos = 0
    if (this.items !== []) {
      pos = this.items.length
    } else {
      pos = 0
          }
          
          // let tablesRef = db.ref('Tables/' + pos)
          // let newTable = {text: this.newTableName, icon: 'table'}
          // tablesRef.update(newTable, function (err) {
          //   if (err) {
          //     console.log(err)
          //   } else {
          //     console.log('header updated')
          //   }
          // })
          this.compileWasmAbi({cols: dispatch, account: this.newTableName})
    
          console.log(dispatch)
        },
        compileWasmAbi: function (data) {
        let self = this
        data = JSON.stringify(data)
        data = btoa(data)
        let wasm
        let abi

        axios
          .get('http://127.0.0.1:3000/createDatabaseCpp/' + data)
          .then(response => (wasm = response))
          .then(axios.get('http://127.0.0.1:3000/createDatabaseHpp/' + data)
          .then(response => (abi = response)))
        
      },
      prepareContractCode: function (data) {
        this.$store.dispatch('contractBuild/prepareContractCode')
      },
    }               
  }
</script>